import '../../style/index.less';
import './index.less';

// style dependencies
import '../../tooltip/style';



// WEBPACK FOOTER //
// ./_antd1.11.2/slider/style/index.js